import type { Components } from '@mui/material';

import { type HorizonTheme } from './horizon-theme';

export const muiTableCell: Components<HorizonTheme>['MuiTableCell'] = {
  styleOverrides: {
    root: {
      boxSizing: 'border-box',
      height: '44px',
      border: 'unset',
      fontSize: 13,
      textAlign: 'left',
      color: '#202227',
      backgroundColor: '#FFF',
    },
    head: {
      fontWeight: 700,
    },
    body: {
      verticalAlign: 'middle',
    },
  },
};
